<template>
  <div class="yht-Header"
       :class="{'yht-Header_white' : theme === 'white', 'yht-Header_brown': theme === 'brown'}">
    <div class="yht-Header_c flex">
      <div @click="goHome">首页</div>
      <div @click="goSystem('qwsjk')">雨花英烈卷宗资料全文数据库</div>
      <div @click="goSystem('zjcgk')">专家成果库</div>
      <div @click="goSystem('ktyj')">协同编撰系统</div>
      <div v-show="userType === '1'" @click="goGcxt">藏品管理系统</div>
    </div>
    <div class="yht-Header_r flex">
      <div class="yht-Header_help cp" @click="goHelp">帮助</div>
      <div v-if="!userName">
        <span @click="goLogin" class="yht-Header_login cp">登录</span>
      </div>
      <div v-else>
        <el-dropdown trigger="click">
          <div  class="yht-Header_user cp" v-text="'欢迎您，' + userName"></div>
          <el-dropdown-menu class="header-new-drop" slot="dropdown">
            <el-dropdown-item @click.native="goPersonInfo">个人中心</el-dropdown-item>
            <el-dropdown-item v-if="userKind === '1'" @click.native="goBackStage">后台管理</el-dropdown-item>
            <el-dropdown-item @click.native="signOut">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
<!--      <div v-else v-text="'欢迎您，' + userName" @click="handleUserInfo" class="yht-Header_user cp"></div>-->
<!--      <div v-show="isPopup" class="yht-Header_popup">-->
<!--        <div @click="goPersonInfo" class="yht-Header_popup_user">个人中心</div>-->
<!--        <div @click="goBackStage" v-if="userKind === '1'" class="yht-Header_popup_user">后台管理</div>-->
<!--        <div @click="signOut">退出</div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'header',
  props: {
    theme: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      name: '',
      userName: '',
      userType: '0',
      userKind: '0',
      // 是否显示弹窗
      isPopup: false
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const token = this.$cookies.get('Authorization')
      if (!token) {
        this.name = ''
        this.userType = '0'
        this.userKind = '0'
        this.$store.commit('del_Authorization')
        this.$store.commit('del_name')
        this.$store.commit('del_userName')
        this.$store.commit('del_userType')
        this.$store.commit('del_userKind')
      }
      if (localStorage.getItem('name')) {
        this.name = localStorage.getItem('name')
      } else {
        this.name = ''
      }
      if (localStorage.getItem('userName')) {
        this.userName = localStorage.getItem('userName')
      } else {
        this.userName = ''
      }
      if (localStorage.getItem('userType')) {
        this.userType = localStorage.getItem('userType')
      } else {
        this.userType = '0'
      }
      if (localStorage.getItem('userKind')) {
        this.userKind = localStorage.getItem('userKind')
      } else {
        this.userKind = '0'
      }
    },

    // 跳到登录页
    goLogin (param) {
      this.$router.push('/login')
    },

    // 跳到帮助页面
    goHelp () {
      if (this.$route.name === 'help') {
        return
      }
      const help = this.$router.resolve({ path: '/help' })
      window.open(help.href, '_blank')
    },

    goHome () {
      const name = this.$route.name
      if (name === 'home') {
        return
      }
      this.$router.push('/home')
    },

    // 跳转子系统
    goSystem (param) {
      let url = ''
      switch (param) {
        case 'qwsjk':
          url = 'http://files.travel-yuhuatai.com:84/dossierHome'
          break
        case 'zjcgk':
          url = 'http://files.travel-yuhuatai.com:82/expertHome'
          break
        case 'ktyj':
          url = 'http://files.travel-yuhuatai.com:81/subject/#/'
      }
      window.open(url, '_blank')
      // if (localStorage.getItem('Authorization')) {
      //   const Authorization = localStorage.getItem('Authorization')
      //   const urlToken = url + '?Authorization=' + Authorization
      //   window.open(urlToken, '_blank')
      // } else {
      //   window.open(url, '_blank')
      // }
    },

    // 跳转馆藏系统
    goGcxt () {
      const url = 'http://files.travel-yuhuatai.com:8001/index'
      // const Authorization = this.$cookies.get('Authorization')
      // const url = `http://localhost:8001/index?Authorization=${Authorization}`
      const element = document.createElement('a')
      element.href = url
      element.target = '_blank'
      element.click()
      document.body.removeChild(element)
    },

    // 显示隐藏弹窗
    handleUserInfo () {
      this.isPopup = !this.isPopup
    },

    // 退出登录
    signOut () {
      const self = this
      axios.post('/yuhuamenhu/user/logout').then(json => {
        if (json.data.code === 201) {
          self.$store.commit('del_Authorization')
          self.$store.commit('del_name')
          self.$store.commit('del_userName')
          self.$store.commit('del_userType')
          self.$store.commit('del_userKind')
          this.$router.replace({
            path: '/login'
          })
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        // self.isLoading = false
      })
    },

    // 跳转个人中心
    goPersonInfo () {
      const personInfo = this.$router.resolve({ path: '/personInfo' })
      window.open(personInfo.href, '_blank')
    },

    // 跳转后台管理
    goBackStage () {
      const backStage = this.$router.resolve({ path: '/backStage/home' })
      window.open(backStage.href, '_blank')
    }
  }
}
</script>

<style src="./index.css"></style>
